import Api from '@/services/Api';

export default {
	async getCustomers(obj) {
		return await Api.post('/api/customers', obj);
	},
	async getArchivedCustomers(obj) {
		return await Api.post('/api/archived-customers', obj);
	},
	async getDeletedCustomers(obj) {
		return await Api.post('/api/deleted-customers', obj);
	},
	async getCustomer(id) {
		return await Api.get(`/api/customer/${id}`);
	},
	async updateCustomer(customer) {
		if (customer.id) {
			return await Api.patch(`/api/customer/${customer.id}`, customer);
		}

		return await Api.post('/api/customer', customer);
	},
	// Soft delete customer
	async softDeleteCustomer(id) {
		return await Api.post('/api/soft-delete-customer', { customer_id: id });
	},
	// Perma delete customer
	async deleteCustomer(id) {
		return await Api.delete('/api/customer', { data: { customer_id: id } });
	},
	async restoreCustomer(id) {
		return await Api.post('/api/restore-customer', { customer_id: id });
	},
	async archiveCustomer(id) {
		return await Api.post('/api/archive-customer', { customer_id: id });
	},
	// Agent Customers
	async getAgentCustomers(obj) {
		return await Api.post('/api/agents-customers', obj);
	},
	async getAgentArchivedCustomers(obj) {
		return await Api.post('/api/agents-archived-customers', obj);
	},
	async agentArchiveCustomer(id) {
		return await Api.post('/api/agent-archive-customer', { customer_id: id });
	},
	async getAgentCustomer(id) {
		return await Api.get(`/api/get-customer/${id}`);
	},
	async updateAgentCustomer(customer) {
		if (customer.id) {
			return await Api.patch(`/api/update-customer/${customer.id}`, customer);
		}

		return await Api.post('/api/store-customer', customer);
	},
	// Soft delete agent customer
	async softDeleteAgentCustomer(id) {
		return await Api.post('/api/soft-agent-delete-customer', { customer_id: id });
	},
	async matchingCustomersByStage(obj) {
		return await Api.post('/api/matching-customers-by-stage', obj);
	},
	// Matching customers
	async matchingCustomers(obj) {
		return await Api.post('/api/matching-customers', obj);
	},
	// Assign property to stage
	async assignPropertyToStage(obj) {
		return await Api.post('/api/assign-property-to-stage', obj);
	},
	// Get properties for matching with current Customer
	async getPropertiesForMatching(filter) {
		return await Api.post('/api/properties-for-matching', filter);
	},
	// Get Lead Dashboard Customers
	async leadDashboardCustomer(data) {
		return await Api.post('/api/lead-dashboard-customer', data);
	},
	// Get Lead Dashboard Customers
	async leadDashboardProperties(data) {
		return await Api.post('/api/lead-dashboard-property', data);
	},
	// Get Assigned Agent/Admins 
	async getCustomerAssigned(obj) {
		return await Api.post('/api/customer/assigned', obj);
	},
	async leadDashboardCustomerStages(obj) {
		return await Api.post('/api/lead-dashboard-customer-stages', obj);
	},
	async leadDashboardPropertyStages(obj) {
		return await Api.post('/api/lead-dashboard-property-stages', obj);
	}
};
